import React, { useState} from 'react';
import styled from 'styled-components';
import BodyInicio from './Components/BodyInicio/BodyInicio';

import HeaderInicio from './Components/HeaderInicio';
import Parcelas from './Components/BodyParcelas/Parcelas';
import Servicios from './Components/Servicios';
import Nosotros from './Components/Nosotros';

import imgInicioStatic from './images/Logo.jpeg';

const  App = () => {

  const [inpAbrirMenu, setinpAbrirMenu] = useState(false);
  const [viewMenu, setviewMenu] = useState({
    viewInicio: true,
    viewParcelas: false,
    viewServicios:false,
    viewNosotros:false
  });

  const openNosotros = (e) => {
    setviewMenu({...viewMenu,
      viewInicio: false,
      viewParcelas: false,
      viewServicios:false,
      viewNosotros:true
    })
    setinpAbrirMenu(e.target.checked)
    e.preventDefault();
  }
  const openServicios = (e) => {
    setviewMenu({ ...viewMenu,
      viewInicio: false,
      viewParcelas: false,
      viewServicios:true,
      viewNosotros:false
    })
    setinpAbrirMenu(e.target.checked)
    e.preventDefault();
  }

  const openParcelas = (e) => {
    setviewMenu({...viewMenu,
      viewInicio:false,
      viewParcelas:true,
      viewServicios:false,
      viewNosotros:false
    })
    setinpAbrirMenu(e.target.checked)
    e.preventDefault();
  }

  const openInicio = (e) => {
    setviewMenu({
      viewInicio:true,
      viewParcelas: false,
      viewServicios:false,
      viewNosotros:false
    })
    setinpAbrirMenu(e.target.checked)
    e.preventDefault();
  }
 
  return (
    <AppCSS>
      <div className="imgInicioStatic">
        <img src={ imgInicioStatic} alt="/"/>
      </div>
      <HeaderInicio
        inpAbrirMenu = {inpAbrirMenu}
        viewInicio = { viewMenu.viewInicio }
        viewParcelas = { viewMenu.viewParcelas }
        setinpAbrirMenu = {setinpAbrirMenu}
        openParcelas = { openParcelas }
        openInicio = { openInicio }
        openServicios = { openServicios }
        openNosotros = { openNosotros }
      />
      <BodyInicio 
        viewInicio = { viewMenu.viewInicio }
      />
      <Parcelas viewParcelas = { viewMenu.viewParcelas }></Parcelas>
      <Servicios
        viewServicios = { viewMenu.viewServicios} >
      </Servicios>
      <Nosotros viewNosotros = {viewMenu.viewNosotros}></Nosotros>
    </AppCSS>
  );
}

export default App;

const AppCSS = styled.div`
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  .imgInicioStatic {
    width: 65%;
    height: 85%;
    float: right;
    left: 17.5%;
    top:12%;
    position: fixed;
    z-index:1;
    @media(max-width: 768px) {
      width: 100%;
      height: 80%;
      left: 0%;
      top:18%;
    }
    @media(max-width: 480px) {
      width: 100%;
      height: 60%;
      left: 0%;
      top:23%;
    }
    @media(max-width: 320px) {
      width: 100%;
      height: 50%;
      left: 0%;
      top:30%;
    }
  }
  .imgInicioStatic img {
    width: 100%;
    height: 100%;
    position:relative;
  } 
`;
